import { useState } from 'react';
import { FormBehavior, observer, useNavigate } from '~/modules';
import { Routes } from '~/routes';
import { useStores } from '~/utils';
import OnboardingCep from './OnboardingCep';
import {
  type OnboardingCepFormValues,
  initialValues,
  validationSchema,
} from './schema';

const OnboardingCepContainer = () => {
  const navigate = useNavigate();
  const { user } = useStores();
  const [loading, setLoading] = useState(false);
  const onSubmit = async (values: OnboardingCepFormValues) => {
    setLoading(true);
    user.updateAddressData({
      cep: values.cep,
    });
    await user.getAddressByCEP();
    setLoading(false);
    navigate(Routes.ONBOARDING_ADDRESS);
  };
  return (
    <FormBehavior
      validationSchema={validationSchema}
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      <OnboardingCep loading={loading} />
    </FormBehavior>
  );
};

export default observer(OnboardingCepContainer);
